import React from 'react'
import NavBar from 'templates/NavBar'
import NetworkNav from './components/NetworkNav'
import MainNav from './components/MainNav'

function DesktopHeader (props) {
  return (
    <NavBar>
      <NetworkNav />
      <MainNav />
    </NavBar>
  )
}

export default DesktopHeader



// WEBPACK FOOTER //
// ./src/organisms/Header/DesktopHeader/DesktopHeader.js